
export default {
  props: {
    argumentsTwo: {
      type: Array,
      default: () => {
        return [
          {
            img: "argument-web-1.png",
            title: "Présentez votre activité",
            text: "Exposez votre histoire et vos qualifications au grand public tout en mettant en avant votre savoir-faire.",
            alt: "Votre activité sur le web",
          },
          {
            img: "argument-web-2.png",
            title: "Valorisez vos prestations",
            text: "Mettez votre expertise en lumière ! Soyez fiers de vos compétences et mettez en avant vos services, vos tarifs et vos zones d’intervention sur le web.",
            alt: "Une page web dédiée à vos services",
          },
          {
            img: "argument-web-3.png",
            title: "Soyez joignable facilement",
            text: "Rendez visibles vos coordonnées téléphoniques, horaires d’ouverture et formulaire de contact pour faciliter les demandes de contact.",
            alt: "Site internet avec page contact",
          },
        ];
      },
    },
  },
};
